import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from 'store/store'
import routes from './routes'
import { startSignalR } from './signalR'
import { OidcProvider } from 'redux-oidc'
import { userManager } from 'auth/userManager'
import App from './app'
import 'polyfills/startsWith'

import 'assets/scss/index.scss'
require('dotenv').config()

startSignalR(store)

render(
  <Provider store={store}>
    <OidcProvider store={store} userManager={userManager}>
      <App>
        <ConnectedRouter history={history}>
          {routes}
        </ConnectedRouter>
      </App>
    </OidcProvider>
  </Provider>,
  document.querySelector('#root')
)
